module.exports = __webpack_public_path__ + "static/media/logo.35d2c7c6.svg";